import { useBooleanFlagValue } from "@utilitywarehouse/feature-flags-react";

import { useVulnerabilityContext } from "../context/vulnerability/useVulnerabilityContext";
import { useHasLiveEnergyService } from "../graphql/customer/useHasLiveEnergyService";
import Features from "../middleware/featureFlags/constants/features";
import { checkIfPsrAnswersAreEmpty } from "../pages/utils";

export const useCustomerIsEligibleForPsr = (): boolean => {
  const hasLiveEnergyService = useHasLiveEnergyService();
  const { answers } = useVulnerabilityContext();
  const hasAbilityToOptIntoPSR = useBooleanFlagValue(Features.psrOptIn, false);

  const isEligibleForPSR = hasAbilityToOptIntoPSR && hasLiveEnergyService && !checkIfPsrAnswersAreEmpty(answers);

  return isEligibleForPSR;
}
